<template>
  <div class="device-ct">
    <PullDown v-if="!hidePullDown" style="margin-top: 0;"></PullDown>
    <div class="nav">
      <div class="module-title">
        医学成人模型
      </div>

      <div class="ct-content">
        <div class="single-col-card">
          <!-- 1. 标题 + 主轮播 -->
          <h5 class="title_T">{{titleT[0]}}</h5>
          <div class="main-banner carImg">
            <el-carousel>
              <el-carousel-item v-for="item in imgUrl[0]" :key="item">
                <img style="object-fit: cover;" class="carousel_img banner-img" :src="item" alt=""/>
                <div class="banner-glow"></div>
              </el-carousel-item>
            </el-carousel>
          </div>

          <!-- 2. 三段描述文字 -->
          <div class="text-wrap">
            <p class="text-content">{{p[0]}}</p>
            <p class="text-content">{{p[1]}}</p>
            <p class="text-content">{{p[2]}}</p>
          </div>

          <!-- 3. 产品部件 -->
          <h5 class="title_T">{{titleT[1]}}</h5>
          <div style="display: flex;flex-wrap: wrap;justify-content: space-between">
            <el-image lazy class="proParts main-banner" :preview-src-list="imgUrl[1]" v-for="item in imgUrl[1]" :key="item" :src="item" alt=""/>
          </div>

          <!-- 4. 产品图片轮播 -->
          <h5 class="title_T">{{titleT[2]}}</h5>
          <div class="main-banner proImg">
            <el-carousel>
              <el-carousel-item style="display: flex;justify-content: space-between" v-for="(item,index) in imgUrl.slice(2,5)" :key="index">
                <img class="forImg banner-img" v-for="iem in item" :key="iem" :src="iem" alt=""/>
              </el-carousel-item>
              <div class="banner-glow"></div>
            </el-carousel>
          </div>

          <!-- 5. 产品特性标签 -->
          <h5 class="title_T">{{titleT[3]}}</h5>
          <div style="display: flex;flex-wrap: wrap;padding: 0 3px;gap: 2%;justify-content: space-between;">
            <div class="tagWidth" :style="{marginBottom: tags.length-1 == index ? '0' : '16px'}" v-for="(tag,index) in tags" :key="tag">
              <el-tag effect="dark">
                <i class="el-icon-success"></i>
                {{tag}}
              </el-tag>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PullDown from "@/components/home/pullDown.vue";

export default {
  props: {
    hidePullDown: {
      type: Boolean,
      default: false // 默认显示
    }
  },
  name: "FullBodyRadioModel",
  components: {
    PullDown
  },
  data(){
    return{
      wWidth: window.innerWidth,
      titleT: ['成人全身模型','——产品部件——','——产品图片——','——产品特性——','——适用场景（X线,CT,MRI）——',],
      tags: [
        '完整的人体（10个部分）',
        '逼真的身体和肌肉组织模仿材质',
        '支持透明肤色或定制肤色',
        '可移动的髋关节、膝关节和肘关节',
        '可拆卸的头部、躯干和四肢',
        '成人比例手臂、头部、躯干、腿部',
        '可旋转的肩部（360°旋转和180°侧向）'
      ],
      p: [
        '成人全身模型是一款与X射线/CT和MRI兼容的训练产品。这款模型的主要应用是在放射学中训练和演示各种病人定位技术。其他用途包括获取诊断成像技术的实践经验和视觉评估，以寻找最佳的扫描条件。',
        '在MRI应用方面，模型组织具有逼真的T2弛豫时间值，这使得该产品非常适合任何T2加权MRI成像方法。使用质子密度成像方法也可以获得非常好的结果。尽管模型仍然可以使用T1加权方法成像，但T1值不够逼真，大约在100毫秒范围内。',
        '这款模型的模型基于一个体重约70公斤（154磅），身高172厘米（69英寸）的成年男性身体。骨骼是由专利的环氧基复合材料单独铸造而成，具有逼真的三层结构和内部多孔性，可以根据特定项目的要求进行调整。模型可以根据需要定制，以包含不同的病理情况（病变、肿瘤、感染、异常）。这款定位模型可以订购透明或肤色版本。'
      ],
      h6:[
        {
          title:'X线扫描',
          imgUrl: [
            require('@/assets/newModel/FullBodyXRAY1.jpg'),
            require('@/assets/newModel/FullBodyXRAY2.jpg'),
            require('@/assets/newModel/FullBodyXRAY3.jpg'),
            require('@/assets/newModel/FullBodyXRAY4.jpg'),
            require('@/assets/newModel/FullBodyXRAY5.jpg'),
            require('@/assets/newModel/FullBodyXRAY6.jpg'),
            require('@/assets/newModel/FullBodyXRAY7.jpg'),
            require('@/assets/newModel/FullBodyXRAY8.jpg'),
            require('@/assets/newModel/FullBodyXRAY9.jpg'),
            require('@/assets/newModel/FullBodyXRAY10.jpg'),
            require('@/assets/newModel/FullBodyXRAY11.jpg'),
            require('@/assets/newModel/FullBodyXRAY13.jpg'),
            require('@/assets/newModel/FullBodyXRAY14.jpg'),
            require('@/assets/newModel/FullBodyXRAY15.jpg'),
            require('@/assets/newModel/FullBodyXRAY16.jpg')
          ],
          num: 5
        },
        {
          title:'CT扫描',
          imgUrl: [
            require('@/assets/newModel/CT_1.png'),
            require('@/assets/newModel/CT_2.png'),
            require('@/assets/newModel/CT_3.png'),
            require('@/assets/newModel/CT_4.png'),
            require('@/assets/newModel/CT_5.png'),
            require('@/assets/newModel/CT_6.png')
          ],
          num: 3
        },
        {
          title:'MRI扫描',
          imgUrl: [
            require('@/assets/newModel/MRI_1.jpg'),
            require('@/assets/newModel/MRI_2.jpg'),
            require('@/assets/newModel/MRI_3.jpg'),
            require('@/assets/newModel/MRI_4.jpg'),
            require('@/assets/newModel/MRI_5.jpg')
          ],
          num: 5
        }
      ],
      imgUrl:[
        [
          require('@/assets/newModel/fullBody3.png'),
          require('@/assets/newModel/fullBody4.png'),
          require('@/assets/newModel/fullBody5.png'),
        ],
        [
          require('@/assets/newModel/Full-Body1.jpg'),
          require('@/assets/newModel/Full-Body2.jpg'),
          require('@/assets/newModel/Full-Body3.jpg'),
          require('@/assets/newModel/Full-Body4.jpg'),
          require('@/assets/newModel/Full-Body5.jpg')
        ],
        [
          require('@/assets/newModel/Body-11.jpg'),
          require('@/assets/newModel/Body-12.jpg'),
          require('@/assets/newModel/Body-13.jpg')
        ],
        [
          require('@/assets/newModel/Body-14.jpg'),
          require('@/assets/newModel/Body-15.jpg'),
          require('@/assets/newModel/Body-16.jpg')
        ]
      ],
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.wWidth = window.innerWidth;
    }
  },
  created(){
  }
}
</script>

<style lang="scss" scoped>
.device-ct {
  width: 100%;
  padding: 1rem;
  margin-top: 80px;
  background: linear-gradient(180deg, #f0f6ff 0%, #ffffff 100%);
  box-sizing: border-box;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

  @media (max-width: 767px) {
    margin-top: 60px;
    padding: 0.5rem;
  }

  .nav {
    width: 60%;
    margin: 0 auto;
    border: none;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(10px);
    box-shadow: 0 20px 60px rgba(37, 75, 156, 0.10),
                0 8px 24px rgba(37, 75, 156, 0.06);
    transition: all 0.3s ease;
    overflow: hidden;
    margin-top: 20px;

    @media (max-width: 1024px) {
      width: 80%;
    }
    @media (max-width: 767px) {
      width: 100%;
      border-radius: 16px;
      box-shadow: 0 12px 40px rgba(37, 75, 156, 0.08);
    }

    &:hover {
      box-shadow: 0 24px 72px rgba(37, 75, 156, 0.14);
    }
  }

  .module-title {
    padding: 2.5rem 2rem 1.5rem;
    font-size: 1.75rem;
    font-weight: 700;
    color: #1a365d;
    text-align: center;
    letter-spacing: 0.04em;
    position: relative;
    background: linear-gradient(135deg, #f8faff 0%, #eef4ff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;

    @media (max-width: 767px) {
      font-size: 1.25rem;
      padding: 1.5rem 1rem 1rem;
      gap: 8px;
    }

    &::after {
      content: "";
      width: 100px;
      height: 4px;
      background: linear-gradient(90deg, #2563eb, #60a5fa, #2563eb);
      border-radius: 4px;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .ct-content {
    padding: 2.5rem 3rem 3rem;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    gap: 48px;

    @media (max-width: 1024px) {
      padding: 2rem 2rem 2.5rem;
      gap: 36px;
    }
    @media (max-width: 767px) {
      padding: 1.5rem 1rem 1.5rem;
      gap: 28px;
    }
  }

  .single-col-card {
    background: #fff;
    display: flex;
    flex-direction: column;
    gap: 32px;
    width: 100%;
    margin: auto;
  }

  // 全局统一文字样式
  .text-content {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 0.95rem;
    line-height: 2;
    color: #1e293b;
    text-align: justify;
    letter-spacing: 0.01em;
    position: relative;
    padding-left: 1rem;
    border-left: 3px solid transparent;

    @media (max-width: 767px) {
      font-size: 0.85rem;
      line-height: 1.85;
      padding-left: 0.75rem;
    }

    &:first-of-type {
      margin-bottom: 2rem;
      border-left-color: #3b82f6;
      background: linear-gradient(90deg, rgba(59, 130, 246, 0.04) 0%, transparent 100%);
      padding: 0.75rem 1rem 0.75rem 1.5rem;
      border-radius: 0 8px 8px 0;

      @media (max-width: 767px) {
        padding: 0.5rem 0.75rem 0.5rem 1rem;
      }
    }

    &:last-of-type {
      margin-bottom: 2rem;
      border-left-color: #3b82f6;
      background: linear-gradient(90deg, rgba(139, 92, 246, 0.04) 0%, transparent 100%);
      padding: 0.75rem 1rem 0.75rem 1.5rem;
      border-radius: 0 8px 8px 0;

      @media (max-width: 767px) {
        padding: 0.5rem 0.75rem 0.5rem 1rem;
      }
    }
  }

  .title_T {
    font-size: 1.1rem;
    line-height: 2.2;
    color: #2563AF;
    margin: 0;
  }

  // 轮播大图统一样式
  .carImg.main-banner,
  .proImg.main-banner {
    position: relative;
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 8px 30px rgba(26, 75, 140, 0.12);
    width: 100%;
  }
  .banner-glow {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 45%;
    background: linear-gradient(to top, rgba(26, 75, 140, 0.22), transparent);
    pointer-events: none;
    z-index: 1;
  }
  .banner-img {
    width: 100%;
    display: block;
    transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
  }
  .main-banner:hover .banner-img {
    transform: scale(1.035);
  }

  :deep(.el-carousel__container) {
    height: 437px;
  }

  // 部件小图
  .proParts.main-banner {
    position: relative;
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 8px 30px rgba(26, 75, 140, 0.12);
    width: 18%;
    transition: all 0.3s ease;
    img {
      width: 100%;
      height: auto;
      transition: transform 0.4s ease;
    }
    &:hover img {
      transform: scale(1.04);
    }
  }

  .forImg {
    width: 32%;
    border-radius: 8px;
    overflow: hidden;
    transition: transform 0.4s ease;
    &:hover {
      transform: scale(1.04);
    }
  }
  .forImg + .forImg {
    margin-left: 20px;
  }

  // 标签区域
  .tagWidth {
    width: 48%;
  }
  :deep .el-tag {
    text-align: left;
    width: 40vh;
  }
  :deep .el-tag--dark {
    background-color: #0969B2;
    border-color: #0969B2;
  }
  .el-tag + .el-tag {
    margin-left: 20px;
  }

  // 轮播箭头穿透样式
  :deep .el-carousel__arrow {
    background-color: rgba(44, 139, 218, 0.53);
  }
  .proImg :deep .el-carousel__container{
    height: 37vh;
  }

  // 移动端适配
  @media only screen and (max-width: 767px){
    .tagWidth {
      width: 100%;
    }
    .carImg :deep .el-carousel__container{
      height: 17vh;
    }
    .proImg :deep .el-carousel__container{
      height: 19vh;
    }
    .proParts {
      width: 47.5%;
    }
    .proParts:not(:last-child) {
      margin-bottom: 20px;
    }
    :deep .el-tag {
      width: 100%;
    }
  }
}

// 暗色模式适配
@media (prefers-color-scheme: dark) {
  .device-ct {
    background: linear-gradient(180deg, #0f1724 0%, #0a0f1a 100%);

    .nav {
      background: rgba(20, 30, 50, 0.92);
      backdrop-filter: blur(12px);
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);

      .module-title {
        color: #93bbfc;
        background: linear-gradient(135deg, #0f1a2e 0%, #162035 100%);
        &::after {
          background: linear-gradient(90deg, #1d4ed8, #60a5fa, #1d4ed8);
        }
      }

      .ct-content {
        background: #0f1a2e;
        .single-col-card {
          background: #142033;
        }
        .text-content {
          color: #c8d6e8;
          &:first-of-type {
            background: linear-gradient(90deg, rgba(59, 130, 246, 0.08) 0%, transparent 100%);
          }
          &:last-of-type {
            background: linear-gradient(90deg, rgba(139, 92, 246, 0.08) 0%, transparent 100%);
          }
        }
        .title_T {
          color: #60a5fa;
        }
      }
    }
  }
}

// 全局导航统一穿透样式
:deep .global-nav[data-v-5e75b752]{
    background: none;
    border: none;
    box-shadow: none;
    padding: 0 0;
    width: 100%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}
:deep .global-nav .nav-item .nav-title.active[data-v-5e75b752]:hover {
  color: #0f3059;
  background: transparent;
}
</style>